(ns ui.view.entity-graph.node
  (:require [re-frame.core :as rf]
            [ui.view.entity-graph.model :as m]
            [ui.view.entity-graph.components.node :as node-components]))

(def types
  {:company-node #'node-components/company-node
   :person-node #'node-components/person-node
   :fund-node #'node-components/fund-node
   :annotation-node #'node-components/annotation-node})

(defn ephemeral?
  [{:keys [type]}]
  (or (= type "dimensions")
      (= type "position")))

(defn ephemeral-changes
  [events]
  (let [position-events (->> events
                             (filterv (fn [{:keys [type]}]
                                        (= type "position")))
                             (mapv (fn [e]
                                     (update e :id parse-long))))
        ;; dragging ends => remove from ephemeral (saved to view-config-state)
        remove-positions (->> position-events
                              (filterv (complement :dragging))
                              (mapv :id))
        positions (->> position-events
                       (filterv :dragging)
                       (mapv (fn [{:keys [id position]}]
                               [id position]))
                       (into {}))
        ;; not needed? fixed width and height:
        #_#_dimensions (->> events
                        (filterv (fn [{:keys [type]}]
                                   (= type "dimensions")))
                        (mapv (fn [{:keys [id dimensions]}]
                                [id dimensions]))
                        (into {}))]
    {:positions positions
     :remove-positions remove-positions}))

(defn select?
  [{:keys [type]}]
  (= type "select"))

(defn view-config-change?
  [{:keys [type dragging]}]
  (and (= type "position")
       (not dragging)))

(defn select-changes
  [selects]
  (let [selected (->> selects
                      (into #{}
                            (comp
                             (filter :selected)
                             (map :id)
                             (map parse-long))))
        unselected (->> selects
                        (into #{}
                              (comp
                               (remove :selected)
                               (map :id)
                               (map parse-long))))]
    {:select selected
     :unselect unselected}))

(defn view-config-changes
  [events]
  (let [positions (->> events
                       ;; for now all view-config-events are "position" events:
                       #_(filterv (fn [{:keys [type]}]
                                  (= type "position")))
                       (mapv (fn [{:keys [id position]}]
                               [(parse-long id) position]))
                       (into {}))]
    {:positions positions}))

(defn handle-changes
  [ctx changes]
  (let [ephemeral (->> changes
                       (filterv ephemeral?)
                       ephemeral-changes)
        selects (->> changes
                     (filterv select?)
                     select-changes)
        view-config (->> changes
                         (filterv view-config-change?)
                         view-config-changes)]
    (rf/dispatch-sync [m/node-changes ctx {:ephemeral ephemeral
                                           :selects selects
                                           :view-config view-config}])))
